export function isElementFullyInViewport(element: HTMLElement): boolean {
  const boundingClientRect = element.getBoundingClientRect()
  const windowBottomY = window.innerHeight || document.documentElement.clientHeight
  const windowRightSideX = window.innerWidth || document.documentElement.clientWidth
  return (
    boundingClientRect.bottom <= windowBottomY &&
    boundingClientRect.right <= windowRightSideX &&
    boundingClientRect.top >= 0 &&
    boundingClientRect.left >= 0
  )
}

export function nodeIsElement(obj: Node): obj is Element {
  return obj.nodeType === 1
}

export function isHtmlButtonElement(value: HTMLElement): value is HTMLButtonElement {
  return value.constructor === HTMLButtonElement
}
